import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import {Doughnut } from 'react-chartjs-2'
import CardHeader from '../card/CardHeader';
import {  MwSpinnerButton } from '../ui';
import { useInvoice } from '../../hooks';
import { useMemo } from 'react';


ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
)

const DaugeChart = ({labels,labelMetrics ,datasetLabel ,datasetData, className,datasetDataLabel ,loading=true}) => {
    const {formatter} = useInvoice();
    const palette = useMemo(() => {
        if (typeof window === 'undefined') {
            return { primary: '#070b0f', track: '#E2E8F0' };
        }
        const computed = getComputedStyle(document.documentElement);
        const primary = computed.getPropertyValue('--brandColor')?.trim() || '#070b0f';
        const track = '#E2E8F0';
        return { primary, track };
    }, []);

    const data = useMemo(() => ({
        labels: labels,
        datasets:[
            {
                label:datasetLabel ,
                data:datasetData,
                borderColor: [palette.primary, palette.track],
                backgroundColor: [palette.primary, palette.track],
                tension:0.4,
                circumference:180,
                rotation:270
            }
        ]
    }), [labels, datasetLabel, datasetData, palette])
    const options = {
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: 14,
                        family: '"Cairo", sans-serif',
                    }
                }
            }
        }
    }

    const safeLabelMetrics = Number(labelMetrics);
    const displayLabelMetrics = Number.isFinite(safeLabelMetrics) ? safeLabelMetrics : 0;

    return ( 
            <div className={`justify-between items-between px-3 pb-2 border-2 rounded-2xl brand-border bg-white ${className}`.trim()}>
                <CardHeader className="py-2">{datasetLabel}</CardHeader>
                <div className='text-center brand-text font-bold'>{formatter.format(displayLabelMetrics)}</div>
                { !loading ? <div>
                    <Doughnut 
                        data={data}
                        options={options}
                    >
                    </Doughnut>
                    <div className='flex flex-row-reverse justify-between items-between w-full brand-text'>
                        { datasetDataLabel?.map((item,index) => (
                            <div key={index} >
                                <span className='text-xs font-bold '>{ !isNaN(parseFloat(item)) ? formatter.format(item) : '0' }</span>
                            </div>
                        ))}
                    </div> 
                </div> : <MwSpinnerButton withLabel={false} isFullCenter={true} /> }
            </div>
    )
}

export default DaugeChart
